// extracted by mini-css-extract-plugin
export var caseStudies = "case-study-module--caseStudies--9uti+";
export var list = "case-study-module--list--jNa4d";
export var sbShowMain = "case-study-module--sb-show-main--6SwSO";